var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 0.333496C3.32665 0.333496 0.333313 3.32683 0.333313 7.00016C0.333313 10.6735 3.32665 13.6668 6.99998 13.6668C10.6733 13.6668 13.6666 10.6735 13.6666 7.00016C13.6666 3.32683 10.6733 0.333496 6.99998 0.333496ZM9.89998 9.38016C9.80665 9.54016 9.63998 9.62683 9.46665 9.62683C9.37998 9.62683 9.29331 9.60683 9.21331 9.5535L7.14665 8.32016C6.63331 8.0135 6.25331 7.34016 6.25331 6.74683V4.0135C6.25331 3.74016 6.47998 3.5135 6.75331 3.5135C7.02665 3.5135 7.25331 3.74016 7.25331 4.0135V6.74683C7.25331 6.98683 7.45331 7.34016 7.65998 7.46016L9.72665 8.6935C9.96665 8.8335 10.0466 9.14016 9.89998 9.38016Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f7549b16558015ae016c969645e7a2a5.svg";
export { ForwardRef as ReactComponent };